import React from 'react';

const PageLoading = () => <div className="loading align-items-center d-flex h-100 justify-content-center">
  <span className="spinner"></span>
</div>

export const ContentLoading = () => <div className="content-loading loading">
<span className="spinner"></span>
</div>

export default PageLoading;